import { Layout } from 'antd';
import { ReactNode } from 'react';
import styled from 'styled-components';

import EmployeesNavBar from '~/pages/layouts/EmployeesNavBar';

const { Content } = Layout;

type IProps = {
  children: ReactNode;
};

function EmployeesLayout({ children }: IProps) {
  return (
    <>
      <Layout style={{ minHeight: '100%', width: 'auto' }}>
        <EmployeesNavBar />
        <Layout>
          <SContent>{children}</SContent>
        </Layout>
      </Layout>
    </>
  );
}

export default EmployeesLayout;

const SContent = styled(Content)`
  padding: 10px;
`;
